import EmptyFolder from 'app/design/images/empty-folder';
import Shed from 'app/design/images/shed';

export const EmptyImageComponents = {
  EmptyFolder,
  Shed,
};
